// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconSafetyProtecting = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M19 13.814v2.833a13.69 13.69 0 01-14 0v-2.833a4 4 0 110-8l1.855.53a4.06 4.06 0 003.13-.379 4.06 4.06 0 014.03 0 4.06 4.06 0 003.13.379L19 5.814a4 4 0 010 8m2-4a2 2 0 01-2 2v-4a2 2 0 012 2m-16 2a2 2 0 110-4zm12 3.635a11.69 11.69 0 01-10 0V8.422a6.06 6.06 0 003.978-.72 2.06 2.06 0 012.044 0 6.06 6.06 0 003.978.72zm-8-2.635h6v-2H9z"
    />
  );
export default SvgIconSafetyProtecting;
